module.exports = __webpack_public_path__ + "img/tk.5a5f2901.svg";